import { Injectable } from '@angular/core';
import { IFundCommitmentOverview, IFundFamily } from '@common/models/IFundFamily';
import { ApiService } from '@app/core/services/api.service';
import { Observable, shareReplay } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FundFamilyService {

    private fundFamilyCache$: Observable<IFundFamily[]> | null = null;

    constructor(private readonly apiService: ApiService) { }

    public getAll(): Observable<IFundFamily[]> {
        if (!this.fundFamilyCache$) {
            this.fundFamilyCache$ = (this.apiService.get('FundFamily') as Observable<IFundFamily[]>).pipe(shareReplay(1));
        }
        return this.fundFamilyCache$;
    }

    saveCommitmentOverview(data: { [fund: string]: IFundCommitmentOverview }, quarter: string) {
        return this.apiService.post('FundFamily/CommitmentOverview/' + quarter, data);
    }

    exportCommitmentOverview(quarter: string) {
        return this.apiService.getV2(`FundFamily/Export/CommitmentOverview/${quarter}`, {
            responseType: 'arraybuffer'
        });
    }

}
